
@if (isVisible) {
  <div class="fixed inset-0 bg-[#063057] bg-opacity-[8%] z-40">
    <div class="fixed top-4 right-4 z-50 flex justify-end ">
      <div [ngClass]="getToastColor()" 
           class="flex items-center min-w-fit max-w-full h-[56px] px-4 text-gray-500 divide-gray-200 rounded-[16px] shadow-sm ">
        <span class="mt-1"><i [class]="icon"></i></span>
        <span class="whitespace-nowrap text-[#272B34] text-[14px] font-semibold ml-2">{{message}}</span>
      </div>
    </div>

  </div>


}
